
import { RevIllustration } from '@ds/components/Illustration'
import { RevLink } from '@ds/components/Link'
import { RevSkeleton } from '@ds/components/Skeleton'

import { PRODUCT_SOURCE_TYPE, saveProductInfos } from '@tracking'
import { trackProductClick } from '@tracking/events'

import PriceWithCrossedPrice from '../../PriceWithCrossedPrice/PriceWithCrossedPrice.vue'
import translations from '../../ProductCardContainer.translations'
import { SOURCES, STATUSES } from '../RecommendationBundle.constants'

export default {
  components: {
    RevIllustration,
    RevSkeleton,
    PriceWithCrossedPrice,
  },
  props: {
    horizontal: {
      type: Boolean,
      default: false,
    },
    listing: {
      type: Object,
      required: true,
    },
    status: {
      type: String,
      required: true,
    },
    withInformations: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    translations: () => translations,
    classes() {
      return [
        'flex',
        {
          'flex-row items-center': this.horizontal,
          'flex-col items-center justify-between': !this.horizontal,
        },
      ]
    },
    illustrationClasses() {
      return {
        'w-[88px] h-[88px] mr-2': this.horizontal,
        'w-[136px] h-[136px]': !this.horizontal,
      }
    },
    informationsClasses() {
      return [
        'flex flex-col',
        {
          'text-center items-center mt-7': !this.horizontal,
          'justify-center': this.horizontal,
        },
      ]
    },
    isFetching() {
      return this.status === STATUSES.FETCHING
    },
    isRecommendation() {
      return this.listing.source === SOURCES.RECOMMENDATION_API
    },
    root() {
      if (this.isRecommendation) {
        return {
          component: RevLink,
          props: {
            to: this.listing.link,
            underlined: false,
          },
          listeners: {
            click: this.saveBundleListing,
          },
        }
      }

      return {
        component: 'div',
      }
    },
  },
  methods: {
    saveBundleListing() {
      trackProductClick({
        list: this.listing.trackingData.list,
        product: this.listing.trackingData,
      })

      saveProductInfos({
        id: this.listing?.productId,
        price: this.listing?.price?.raw?.amount,
        source: PRODUCT_SOURCE_TYPE.CROSS_SELL_BUNDLE,
      })
    },
  },
}
